import React from 'react';
import type { ApartmentEditNavText } from '../../i18n/pages/apartmentEditNav';

interface Props {
  text: ApartmentEditNavText;
  /** Group names with edits waiting, already localised and joined for display. */
  unsavedGroups: string[];
  saving: boolean;
  /** The guide's own save is in flight and is sending this same form: nothing here may act. */
  locked?: boolean;
  savingLabel: string;
  onSave: () => void;
  onDiscard: () => void;
}

/**
 * Sticky bar for the shared apartment form: says what is unsaved, and offers Zahodit / Uložit.
 * "Uložit" is the page's existing `saveApartment`, unchanged — this only makes the state visible.
 */
const SaveBar: React.FC<Props> = ({ text, unsavedGroups, saving, locked = false, savingLabel, onSave, onDiscard }) => {
  const dirty = unsavedGroups.length > 0;
  const idle = dirty && !saving && !locked;
  return (
    <div className="ae-savebar" role="region" aria-label={text.barRegion}>
      <span className={`ae-savebar-state${dirty ? ' ae-dirty' : ''}`} role="status" aria-live="polite">
        {locked ? text.barGuideSaving : dirty ? text.barUnsaved(unsavedGroups.join(', ')) : text.barClean}
      </span>
      <span className="ae-savebar-actions">
        <button type="button" className="ae-btn" onClick={onDiscard} disabled={!idle}>
          {text.barDiscard}
        </button>
        <button type="button" className="ae-btn ae-btn-save" onClick={onSave} disabled={!idle} aria-busy={saving || locked}>
          <svg className="ae-save-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12l4 4v12a2 2 0 0 1-2 2Z" />
            <path d="M7 3v6h10V3M7 21v-8h10v8" />
          </svg>
          {saving ? savingLabel : text.barSave}
        </button>
      </span>
    </div>
  );
};

export default SaveBar;
